import { Col } from "components/primitives";
import styled from "styled-components";
import { WidgetSettingFC } from "types/Setting";

import { Phonemes } from "./phonemes";
import { SinglePhonemeSetting } from "./SinglePhonemeSetting";

interface PhonemesSettingInfo {}

type PhonemesSettingData = {
  [id: string]: { disabled: boolean; disabledSounds: string[] };
};

export const PhonemesSetting: WidgetSettingFC<PhonemesSettingData, PhonemesSettingInfo> = ({
  setData,
  info,
  state,
  data,
  settings,
}) => {
  const setGroupEnabled = (key: string, enabled: boolean) => {
    const newData = Object.fromEntries(
      Object.keys(data).map((dataKey) => [dataKey, { ...data[dataKey] }]),
    );
    if (!newData[key]) {
      newData[key] = {
        disabled: !enabled,
        disabledSounds: [],
      };
    } else {
      newData[key].disabled = !enabled;
    }
    setData(newData);
  };

  const setSoundDisabled = (key: string, sound: string, disabled: boolean) => {
    const newData = Object.fromEntries(
      Object.keys(data).map((dataKey) => [dataKey, { ...data[dataKey] }]),
    );
    if (!newData[key]) {
      newData[key] = {
        disabled: false,
        disabledSounds: [],
      };
    }

    if (disabled) {
      if (!newData[key].disabledSounds.includes(sound)) {
        newData[key].disabledSounds.push(sound);
      }
    } else {
      const index = newData[key].disabledSounds.indexOf(sound);
      if (index >= 0) {
        newData[key].disabledSounds.splice(index, 1);
      }
    }
    setData(newData);
  };

  const setAllEnabled = (key: string, enabled: boolean) => {
    const newData = Object.fromEntries(
      Object.keys(data).map((dataKey) => [dataKey, { ...data[dataKey] }]),
    );
    if (!newData[key]) {
      newData[key] = {
        disabled: false,
        disabledSounds: [],
      };
    }
    if (enabled) {
      newData[key].disabledSounds = [];
    } else {
      newData[key].disabledSounds = Phonemes[key].phonemes.map((phoneme) =>
        phoneme.sounds.join("_"),
      );
    }
    setData(newData);
  };

  return (
    <OuterContainer>
      <h2>Phonemes</h2>
      {Object.keys(Phonemes).map((key) => (
        <SinglePhonemeSetting
          enabled={data[key] ? !data[key].disabled : false}
          setEnabled={setGroupEnabled.bind(null, key)}
          disabledSounds={data[key] ? data[key].disabledSounds : []}
          setSoundDisabled={setSoundDisabled.bind(null, key)}
          key={key}
          phonemeData={Phonemes[key]}
          setAllEnabled={setAllEnabled.bind(null, key, true)}
          setAllDisabled={setAllEnabled.bind(null, key, false)}
        />
      ))}
    </OuterContainer>
  );
};

const OuterContainer = styled(Col)`
  h2 {
    font-size: 18pt;
  }
  gap: 15px;
`;
